export default __webpack_public_path__ + "static/media/about.766465df.jpg";